import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TransferDown({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TransferDown</title>
      <path
        d="M21 11.5V16C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16V7C3 5.89543 3.89543 5 5 5H13"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9H11"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14H9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5352 4L17.5352 11.0711M17.5352 11.0711L13.9996 7.53553M17.5352 11.0711L21.0707 7.53553"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
